import { IDbEntity } from "./IDbEntity";
import { IDocument } from "./IDocument";
import { IUser } from "./IUser";

export interface IQdsRequest extends IDbEntity {
    id: number;
    documentId: number;
    document?: IDocument;
    status: QdsStatusEnum;
    consents?: IQdsSignature[];
    holderSignatures?: IQdsSignature[];
    counterPartySignatures: IQdsSignature[];
    documentName: string;
    signedAt?: string;
    createdBy: IUser;
    createdById: number;
    signaturesData?: IDigitalSignatureData[];
}
export interface IQdsSignature  extends IDbEntity {
    id: number;
    qdsRequestId: number;
    type: QdsRequestTypeEnum;
    prio?: number;
    userId?: number;
    user?: IUser;
    status: QdsStatusEnum;
    email: string;
    signedAt?: string;
    confirmedAt?: string;
    token?: string;
    tokenValidUntil?: string;
}

export interface IDigitalSignatureData {
    signingTime: Date;
    jmbg?: string;
    pib?: string;
    firstName?: string;
    lastName?: string;
}

export enum QdsRequestTypeEnum {
    CONSENT = "consent",
    HOLDER_SIGNATURE = "holder_signature",
    COUNTERPARTY_SIGNATURE = "counterparty_signature",
}

export enum QdsStatusEnum {
    PENDING = "pending",
    APPROVED = "approved",
    REJECTED = "rejected",
    SIGNED  = "signed",
}

export interface QdsRequestDTO {
    documentId: number;
    consentEmails: string[];
    holderSignerEmails: string[],
    counterPartyEmails: string[],
}

export interface IQdsRequestMetadata {
    userId?: number;
    email: string;
    prio?: number;
    status: string;
    signedAt?: string;
    createdByUser?: string;
}

export interface IQdsMetadata {
    documentId: number;
    status: string;
    holderSignatures: IQdsRequestMetadata[];
    consents: IQdsRequestMetadata[];
    counterPartySignatures: IQdsRequestMetadata[];
    signaturesData?: IDigitalSignatureData[];
}
